import * as types from "./mutation-types";

export const fetchAccounts = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/super/admin/accounts`, { params })
      .then(response => {
        commit(types.BOOTSTRAP_ACCOUNTS, response.data.accounts.data);
        commit(types.SET_TOTAL_ACCOUNTS, response.data.accounts.total);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchAccount = ({ commit, dispatch }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/super/admin/accounts/${id}/edit`)
      .then(response => {
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const addAccount = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post("/api/super/admin/accounts", data)
      .then(response => {
        commit(types.ADD_ACCOUNT, response.data);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
//
export const updateAccount = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .put(`/api/super/admin/accounts/${data.id}`, data)
      .then(response => {
        if (response.data.success) {
          commit(types.UPDATE_ACCOUNT, response.data);
        }
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const fetchFunderAccounts = ({ commit, dispatch, state }, params) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/super/admin/accounts`, { params })
      .then(response => {
        commit(types.FUNDER_ACCOUNTS, response.data.accounts.data);
        commit(types.SET_TOTAL_FUNDER_ACCOUNTS, response.data.accounts.total);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const fetchFunderFreeAudit = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/super/admin/accounts/funderFreeAudit`, data)
      .then(response => {
        if (response.data.success) {
          commit(types.UPDATE_ACCOUNT, response.data);
        }
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
// export const deleteCustomer = ({ commit, dispatch, state }, id) => {
//   return new Promise((resolve, reject) => {
//     window.axios.delete(`/api/customers/${id}`).then((response) => {
//       commit(types.DELETE_CUSTOMER, id)
//       resolve(response)
//     }).catch((err) => {
//       reject(err)
//     })
//   })
// }
//
// export const deleteMultipleCustomers = ({ commit, dispatch, state }, id) => {
//   return new Promise((resolve, reject) => {
//     window.axios.post(`/api/customers/delete`, {'id': state.selectedCustomers}).then((response) => {
//       commit(types.DELETE_MULTIPLE_CUSTOMERS, state.selectedCustomers)
//       resolve(response)
//     }).catch((err) => {
//       reject(err)
//     })
//   })
// }
//
export const setSelectAllState = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECT_ALL_STATE, data);
};
export const setSelectAllFunderState = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECT_ALL_FUNDER_STATE, data);
};
//
export const selectAllAccounts = ({ commit, dispatch, state }) => {
  if (state.selectedAccounts.length === state.accounts.length) {
    commit(types.SET_SELECTED_ACCOUNTS, []);
    commit(types.SET_SELECT_ALL_STATE, false);
  } else {
    let allAccountIds = state.accounts.map(cust => cust.id);
    commit(types.SET_SELECTED_ACCOUNTS, allAccountIds);
    commit(types.SET_SELECT_ALL_STATE, true);
  }
};

// export const selectAllFunderAccounts = ({ commit, dispatch, state }) => {
//   if (state.selectedFunderAccounts.length === state.funderAccounts.length) {
//     commit(types.SET_SELECTED_FUNDER_ACCOUNTS, [])
//     commit(types.SET_SELECT_ALL_FUNDER_STATE, false)
//   } else {
//     let allFunderAccountIds = state.funderAccounts.map(cust => cust.id)
//     commit(types.SET_SELECTED_FUNDER_ACCOUNTS, allFunderAccountIds)
//     commit(types.SET_SELECT_ALL_FUNDER_STATE, true)
//   }
// }

export const selectAllFunderAccount = ({ commit, dispatch, state }) => {
  commit(types.SET_SELECTED_FUNDER_ACCOUNT, 0);
};

export const selectAccount = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_ACCOUNTS, data);
  if (state.selectedAccounts.length === state.accounts.length) {
    commit(types.SET_SELECT_ALL_STATE, true);
  } else {
    commit(types.SET_SELECT_ALL_STATE, false);
  }
};
export const selectFunderAccount = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_FUNDER_ACCOUNT, data);
};
export const selectAuditAccount = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_AUDIT_ACCOUNT, data);
};
export const selectIslamicForm = ({ commit, dispatch, state }, data) => {
  commit(types.SET_SELECTED_ISLAMIC_FORM, data);
};

selectIslamicForm;
export const connectFunderAuditAccount = (
  { commit, dispatch, state },
  data
) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/super/admin/accounts/connectFunderAuditAccount`, data)
      .then(response => {
        commit(types.SET_SELECTED_AUDIT_ACCOUNT, []);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};
export const connectFunderIslamicForm = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/super/admin/accounts/connectFunderIslamicForm`, data)
      .then(response => {
        commit(types.SET_SELECTED_AUDIT_ACCOUNT, []);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const invoiceSendtoFunderAccounts = (
  { commit, dispatch, state },
  data
) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/super/admin/invoiceSendFunders`, data)
      .then(response => {
        commit(types.SET_SELECT_ALL_FUNDER_STATE, false);
        commit(types.SET_SELECTED_FUNDER_ACCOUNT, []);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const pOSendtoFunderAccounts = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    window.axios
      .post(`/api/super/admin/pOSendFunders`, data)
      .then(response => {
        commit(types.SET_SELECT_ALL_FUNDER_STATE, false);
        commit(types.SET_SELECTED_FUNDER_ACCOUNT, []);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

export const viewAccount = ({ commit, dispatch, state }, data) => {
  return new Promise((resolve, reject) => {
    commit(types.VIEW_ACCOUNT, data);
  });
};

export const fetchViewAccount = ({ commit, dispatch, state }, id) => {
  return new Promise((resolve, reject) => {
    window.axios
      .get(`/api/super/admin/accounts/${id}`)
      .then(response => {
        commit(types.VIEW_ACCOUNT, response.data.account);
        resolve(response);
      })
      .catch(err => {
        reject(err);
      });
  });
};

//
// export const resetSelectedCustomer = ({ commit, dispatch, state }, data) => {
//   commit(types.RESET_SELECTED_CUSTOMER)
// }
